import { Button } from '@codegouvfr/react-dsfr/Button';
import React from 'react';

export const EditOfaInfoStep3 = ({ nbEtablissements, anneeCampagnePrecedente, handleSubmit }: EditOfaInfoStep3Props) => {
    return (
        <div className={'flex flex-col p-6'}>
            <p>
                Nous avons trouvé <strong>{nbEtablissements}</strong> établissement{nbEtablissements > 1 ? 's' : ''} sur
                votre déclaration de l'année <strong>{anneeCampagnePrecedente}</strong>.{' '}
                {nbEtablissements > 1
                    ? "Ils ont automatiquement été rajoutés à votre déclaration de cette année. Vous pouvez les modifier ou les supprimer en étape 2."
                    : "Il a automatiquement été ajouté à votre déclaration de cette année. Vous pouvez le modifier ou le supprimer en étape 2."}
            </p>

            <div className={'flex justify-end gap-2'}>
                <Button type={'button'} onClick={handleSubmit}>SUIVANT</Button>
            </div>
        </div>
    );
};

interface EditOfaInfoStep3Props {
    nbEtablissements: number;
    anneeCampagnePrecedente: number;
    handleSubmit: () => void;
}